import React from 'react';
import { useTheme } from 'next-themes';
import { Monitor, Sun, Moon } from 'lucide-react';

// Auto (follow the device) -> Light -> Dark -> Auto
const ORDER = ['system', 'light', 'dark'];
const LABELS = { system: 'Auto', light: 'Light', dark: 'Dark' };
const ICONS = { system: Monitor, light: Sun, dark: Moon };

const ThemeToggle = ({ className = '', testId = 'theme-toggle-btn' }) => {
  const { theme, setTheme } = useTheme();
  const current = ORDER.includes(theme) ? theme : 'system';
  const next = ORDER[(ORDER.indexOf(current) + 1) % ORDER.length];
  const Icon = ICONS[current];

  return (
    <button
      type="button"
      onClick={() => setTheme(next)}
      className={`inline-flex items-center justify-center rounded-full border border-slate-200 p-2 text-slate-700 hover:border-cyan-300 hover:text-cyan-700 transition-colors ${className}`}
      aria-label={`Theme: ${LABELS[current]}. Switch to ${LABELS[next]}`}
      title={`Theme: ${LABELS[current]} (click for ${LABELS[next]})`}
      data-testid={testId}
      data-theme-choice={current}
    >
      <Icon className="w-4 h-4" aria-hidden="true" />
    </button>
  );
};

export default ThemeToggle;
